"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledIs = _interopRequireWildcard(require("../../utils/styled-is"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _HBLinkButton = _interopRequireDefault(require("../HBLinkButton/HBLinkButton"));
var _HBButton = _interopRequireDefault(require("../HBButton/HBButton"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _Close = _interopRequireDefault(require("@honeybook/icons/dist/icons/Close16"));
var _ArrowRight = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowRight16"));
var _useHBCalloutBannerStyles = require("./useHBCalloutBannerStyles");
var _HBMediaElement = require("../HBMediaElement/HBMediaElement");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBCalloutBanner = function HBCalloutBanner(_ref) {
  var type = _ref.type,
    theme = _ref.theme,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    title = _ref.title,
    description = _ref.description,
    illustration = _ref.illustration,
    _ref$illustrationAspe = _ref.illustrationAspectRatio,
    illustrationAspectRatio = _ref$illustrationAspe === void 0 ? '1:1' : _ref$illustrationAspe,
    _ref$illustrationOrie = _ref.illustrationOrientation,
    illustrationOrientation = _ref$illustrationOrie === void 0 ? 'landscape' : _ref$illustrationOrie,
    _ref$illustrationAlig = _ref.illustrationAlignment,
    illustrationAlignment = _ref$illustrationAlig === void 0 ? 'cover' : _ref$illustrationAlig,
    _ref$illustrationPadd = _ref.illustrationPadding,
    illustrationPadding = _ref$illustrationPadd === void 0 ? false : _ref$illustrationPadd,
    primaryAction = _ref.primaryAction,
    _ref$primaryActionTyp = _ref.primaryActionType,
    primaryActionType = _ref$primaryActionTyp === void 0 ? 'button' : _ref$primaryActionTyp,
    secondaryAction = _ref.secondaryAction,
    onDismiss = _ref.onDismiss,
    className = _ref.className,
    testIdName = _ref.testIdName,
    testId = _ref.testId;
  var calloutBannerStyles = (0, _useHBCalloutBannerStyles.useHBCalloutBannerStyles)(type, theme, size, illustrationAspectRatio, illustrationOrientation);
  var isPrimaryActionTypeLinkButton = primaryActionType === 'link-button';
  var bannerTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'container',
    componentName: 'HBCalloutBanner'
  });
  var primaryActionTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'primary-action',
    componentName: isPrimaryActionTypeLinkButton ? 'HBLinkButton' : 'HBButton'
  });
  var secondaryActionTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'secondary-action',
    componentName: 'HBButton'
  });
  var closeIconTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'close-icon',
    componentName: 'Close16'
  });
  return /*#__PURE__*/_react["default"].createElement(Container, {
    $backgroundColor: calloutBannerStyles.backgroundColor,
    $shadow: calloutBannerStyles.shadow,
    $accentLineColor: calloutBannerStyles.accentLineColor,
    className: className,
    "data-testid": bannerTestId
  }, /*#__PURE__*/_react["default"].createElement(Content, {
    $padding: calloutBannerStyles.padding
  }, /*#__PURE__*/_react["default"].createElement(Title, {
    type: calloutBannerStyles.titleType,
    color: calloutBannerStyles.textColor
  }, title), /*#__PURE__*/_react["default"].createElement(Description, {
    type: calloutBannerStyles.descriptionType,
    color: calloutBannerStyles.textColor
  }, description), /*#__PURE__*/_react["default"].createElement(Footer, null, isPrimaryActionTypeLinkButton ? /*#__PURE__*/_react["default"].createElement(LinkButton, (0, _extends2["default"])({
    linkButtonTheme: calloutBannerStyles.primaryActionLinkButtonTheme,
    size: calloutBannerStyles.linkButtonSize,
    icon: /*#__PURE__*/_react["default"].createElement(Arrow, {
      color: calloutBannerStyles.textColor
    }),
    iconPosition: "end",
    testIdName: primaryActionTestId
  }, primaryAction), primaryAction.text) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_HBButton["default"], (0, _extends2["default"])({
    buttonTheme: calloutBannerStyles.primaryActionButtonTheme,
    size: calloutBannerStyles.buttonSize,
    testIdName: primaryActionTestId
  }, primaryAction), primaryAction.text), secondaryAction && /*#__PURE__*/_react["default"].createElement(_HBButton["default"], (0, _extends2["default"])({
    buttonTheme: calloutBannerStyles.secondaryActionButtonTheme,
    size: calloutBannerStyles.buttonSize,
    testIdName: secondaryActionTestId
  }, secondaryAction), secondaryAction.text)))), illustration && /*#__PURE__*/_react["default"].createElement(IllustrationContainer, {
    $illustrationPlaceholder: calloutBannerStyles.illustrationPlaceholder,
    $illustrationAlignment: illustrationAlignment,
    $illustrationPadding: illustrationPadding
  }, illustration), onDismiss && /*#__PURE__*/_react["default"].createElement(Close, {
    color: calloutBannerStyles.closeColor,
    onClick: onDismiss,
    "data-testid": closeIconTestId
  }));
};
var _default = exports["default"] = HBCalloutBanner;
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutBanner__Container",
  componentId: "sc-1hsjxhi-0"
})(["display:flex;border-radius:4px;", ";"], function (_ref2) {
  var $backgroundColor = _ref2.$backgroundColor,
    $shadow = _ref2.$shadow,
    $accentLineColor = _ref2.$accentLineColor;
  return (0, _styledComponents.css)(["position:relative;background-color:", ";", ";border-left:4px solid ", ";"], $backgroundColor, !!$shadow && (0, _styledComponents.css)(["box-shadow:0 1px 3px 0 rgba(0,18,71,0.16);"]), $accentLineColor);
});
var Content = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutBanner__Content",
  componentId: "sc-1hsjxhi-1"
})(["", ";flex-grow:1;"], function (_ref3) {
  var $padding = _ref3.$padding;
  return (0, _styledComponents.css)(["padding:", "px;"], $padding);
});
var Title = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBCalloutBanner__Title",
  componentId: "sc-1hsjxhi-2"
})(["display:block;"]);
var Description = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBCalloutBanner__Description",
  componentId: "sc-1hsjxhi-3"
})(["margin:4px 0;display:inline-block;"]);
var Footer = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutBanner__Footer",
  componentId: "sc-1hsjxhi-4"
})(["margin-top:8px;display:flex;align-self:start;gap:8px;"]);
var LinkButton = (0, _styledComponents["default"])(_HBLinkButton["default"]).withConfig({
  displayName: "HBCalloutBanner__LinkButton",
  componentId: "sc-1hsjxhi-5"
})(["height:18px;"]);
var Arrow = (0, _styledComponents["default"])(_ArrowRight["default"]).withConfig({
  displayName: "HBCalloutBanner__Arrow",
  componentId: "sc-1hsjxhi-6"
})(["margin-left:-6px;line-height:0;display:block;"]);
var IllustrationContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutBanner__IllustrationContainer",
  componentId: "sc-1hsjxhi-7"
})(["width:min( 35%,", "px );flex-shrink:0;& ", ",& ", "{position:absolute;right:0;max-width:min( 35%,", "px );border-radius:0 4px 4px 0;", ";", ";", ";", ";", ";}"], function (_ref4) {
  var $illustrationPlaceholder = _ref4.$illustrationPlaceholder;
  return $illustrationPlaceholder;
}, _HBMediaElement.StyledMediaImage, _HBMediaElement.StyledMediaVideo, function (_ref5) {
  var $illustrationPlaceholder = _ref5.$illustrationPlaceholder;
  return $illustrationPlaceholder;
}, (0, _styledIs.match)('$illustrationAlignment', 'start')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n            top: 0;\n            max-height: 100%;\n            object-fit: contain;\n        "]))), (0, _styledIs.match)('$illustrationAlignment', 'end')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n            bottom: 0;\n            max-height: 100%;\n            object-fit: contain;\n        "]))), (0, _styledIs.match)('$illustrationAlignment', 'center')(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n            height: 100%;\n            max-height: 100%;\n            object-fit: contain;\n        "]))), (0, _styledIs.match)('$illustrationAlignment', 'cover')(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n            object-fit: cover;\n            height: 100%;\n        "]))), (0, _styledIs["default"])('$illustrationPadding')(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n            padding: 16px;\n        "]))));
var Close = (0, _styledComponents["default"])(_Close["default"]).withConfig({
  displayName: "HBCalloutBanner__Close",
  componentId: "sc-1hsjxhi-8"
})(["position:absolute;top:4px;right:4px;width:30px;height:30px;display:flex;align-items:center;justify-content:center;cursor:pointer;"]);
//# sourceMappingURL=HBCalloutBanner.js.map